import type { ReactNode } from 'react';
import { SplashScreen } from '../app/components/SplashScreen';
import { useAuth } from './AuthContext';

export function AuthGuard({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return <SplashScreen />;
  // AuthProvider.init() handles the redirect to login portal when unauthenticated
  if (!isAuthenticated) return null;
  return <>{children}</>;
}

export default AuthGuard;
